import bridge from '@/plugins/vue-constructor-bridge';
import GoogleTagManager from './google-tag-manager';


const GoogleTagManagerPlugin = {
  install(app, { store, router }) {
    const googleTagManager = GoogleTagManager.init({ store, router, app });

    // Set on the bridge so store files can access it outside component scope.
    // TODO: rename to googleTagManager and update references
    bridge.googleEventTracking = googleTagManager;

    /** Usage: inside of vue components: this.$googleEventTracking */
    // TODO: rename vue prototype method to googleTagManager and update references
    app.config.globalProperties.$googleEventTracking = googleTagManager;
  }
};


export default GoogleTagManagerPlugin;
